import { Handle, Position } from '@xyflow/react'
import { useStyles } from './style'
import { IconButton } from '@material-ui/core'
import { Plus } from 'lucide-react'

const CustomNode = ({ id, data, onAddChild, onAddSibling, onAddMain }) => {
  const classes = useStyles()

  const canHaveSubLevels = Boolean(
    data.hasChildren || data.isMenu || data.isRoot
  )

  const isMainLevelNode =
    data.parentId !== null && parseInt(data.parentId) === parseInt(data.queueId)

  return (
    <article
      className={classes.root}
      aria-label={`Opção de fluxo: ${data.label || 'Sem título'}`}
      tabIndex={0}
    >
      <div className={classes.optionBox}>
        {data.option && (
          <div
            className={classes.optionId}
            aria-label={`Número da opção: ${data.option}`}
          >
            <span>{data.option}</span>
          </div>
        )}
      </div>

      <div className={classes.node}>
        {/* Handle Superior (Entrada) - Ignorado apenas na raiz */}
        {!data.isRoot && (
          <Handle
            type="target"
            position={Position.Top}
            aria-label="Ponto de conexão de entrada"
          />
        )}

        <div>{data.label}</div>

        {/* Handle Inferior (Saída) - Renderizado sempre que houver filhos ou capacidade de ramificação */}
        {canHaveSubLevels && (
          <Handle
            type="source"
            position={Position.Bottom}
            aria-label="Ponto de conexão para subníveis"
          />
        )}
      </div>

      {/* Botão para adicionar irmão principal (à direita) */}
      {isMainLevelNode && data.isLast && (
        <IconButton
          size="small"
          aria-label={`Adicionar nova opção ao lado de ${data.label}`}
          className={`${classes.addButton} ${classes.rightAddButton}`}
          onClick={e => {
            e.stopPropagation()
            onAddMain(id, data)
          }}
        >
          <Plus fontSize="small" />
        </IconButton>
      )}

      {/* Botão para adicionar irmão de sub-setor (à direita) */}
      {!isMainLevelNode && !data.isRoot && data.isLast && (
        <IconButton
          size="small"
          aria-label={`Adicionar novo sub-departamento ao lado de ${data.label}`}
          className={`${classes.addButton} ${classes.rightAddButton}`}
          onClick={e => {
            e.stopPropagation()
            onAddSibling(id, data)
          }}
        >
          <Plus fontSize="small" />
        </IconButton>
      )}

      {/* Botão para adicionar filho (abaixo) */}
      {((data.isRoot && data.isMenu) || (data.isMenu && !data.hasChildren)) && (
        <IconButton
          size="small"
          aria-label={`Adicionar ramificação abaixo de ${data.label}`}
          className={`${classes.addButton} ${classes.bottomAddButton}`}
          onClick={e => {
            e.stopPropagation()
            onAddChild(id, data)
          }}
        >
          <Plus fontSize="small" />
        </IconButton>
      )}
    </article>
  )
}

export default CustomNode
